export const SUBMIT_ECHOSTREAM_MESSAGE = '[ascii] Submit Echostream Message';
export const DISPLAY_ECHOSTREAM_DECODED_MESSAGE = '[ascii] Display Echostream Decoded Message';
export const SUBMIT_FKREPAIR_REQUEST = '[fkrepair] Submit FkRepair Request';
export const DISPLAY_FKREPAIR_RESPONSE = '[FkRepair] Display FkRepair Response';
export const SUBMIT_ASCIIREPAIR_REQUEST = '[asciirepair] Submit AsciiRepair Request';
export const DISPLAY_ASCIIREPAIR_RESPONSE = '[AsciiRepair] Display AsciiRepair Response';
export const SUPPORT_ERROR = '[support] Support Error';
export const GET_QUERYCATALOG_REQUEST = '[QueryCatalog] Get QueryCatalog Request';
export const DISPLAY_QUERYCATALOG_RESPONSE = '[QueryTree] Display QueryCatalog Response';
export const SUBMIT_QUERYEXECUTE_REQUEST = '[QueryTree] Submit QueryExecute Request';
export const DISPLAY_QUERYEXECUTE_RESPONSE = '[QueryTree] Display QueryExecute Response';

export const supportError = (payload) => ({
  type: SUPPORT_ERROR,
  payload,
});

export const submitEchostreamMessage = (payload) => ({
  type: SUBMIT_ECHOSTREAM_MESSAGE,
  payload,
});

export const displayEchostreamDecodedMessage = (payload) => ({
  type: DISPLAY_ECHOSTREAM_DECODED_MESSAGE,
  payload,
});

export const submitFkRepairRequest = (payload) => ({
  type: SUBMIT_FKREPAIR_REQUEST,
  payload,
});

export const displayFkRepairResponse = (payload) => ({
  type: DISPLAY_FKREPAIR_RESPONSE,
  payload,
});

export const submitAsciiRepairRequest = (payload) => ({
  type: SUBMIT_ASCIIREPAIR_REQUEST,
  payload,
});

export const displayAsciiRepairResponse = (payload) => ({
  type: DISPLAY_ASCIIREPAIR_RESPONSE,
  payload,
});

export const getQueryCatalogRequest = (payload) => ({
  type: GET_QUERYCATALOG_REQUEST,
  payload,
});

export const displayQueryCatalogResponse = (payload) => ({
  type: DISPLAY_QUERYCATALOG_RESPONSE,
  payload,
});

export const submitQueryExecute = (payload) => ({
  type: SUBMIT_QUERYEXECUTE_REQUEST,
  payload,
});

export const displayQueryExecuteResponse = (payload) => ({
  type: DISPLAY_QUERYEXECUTE_RESPONSE,
  payload,
});